import dayjs from 'dayjs';

/**
 * The day a booking is created for, as the server is told it.
 *
 * A rental day is a **calendar day**. Cross-border rental does not exist — both sides
 * are always in the same timezone — and the api already enforces this on the other
 * side of the same feature: a dealer's blackout is accepted only as `YYYY-MM-DD` and
 * refused if it carries a time.
 *
 * The price quote has always sent the picked day as-is. Creating the deal used to send
 * `dayjs(day).startOf('day').toISOString()` instead — local midnight expressed in UTC —
 * so in UTC+3 a booking priced for the 10th was created starting `2026-09-09T21:00:00Z`.
 * The buyer was quoted one interval and booked another, and the dealer's calendar was
 * blocked from the wrong day.
 *
 * Quote and booking must speak about the same interval, so both send the day itself.
 */
export function rentalBookingDay(pickedDay: string): string {
  return dayjs(pickedDay).format('YYYY-MM-DD');
}
